/* eslint-disable dot-notation */
import axios from "axios";

const setAuthToken = (token) => {
  if (token) {
    const newToken = token.split(" ");
    // apply to every request
    axios.defaults.headers.common["Authorization"] = newToken[1];
    // axios.defaults.headers["Access-Control-Allow-Credentials"] = true;
  } else {
    // delete the auth header
    delete axios.defaults.headers.common["Authorization"];
    // axios.defaults.headers["Access-Control-Allow-Credentials"] = true;
  }
};

export default setAuthToken;
